export default "__VITE_ASSET__CeIf6uO4__"